import { Component, OnInit, HostListener, ViewChild, ElementRef, DoCheck, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { EmailService } from './service/email.service';
import { NgxLoadingConfig, ngxLoadingAnimationTypes } from 'ngx-loading';
import { MessageService } from './service/message.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, DoCheck {

  width: number;
  items: MenuItem[];
  scrollPosition: number;
  formOrcamento: FormGroup;
  formContato: FormGroup;
  loading: boolean;
  config: NgxLoadingConfig;
  msg: string;
  dadosModal = null;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  @ViewChild('brandMenu') brandMenu: ElementRef<HTMLElement>;
  @ViewChild('navMenu') navMenu: ElementRef<HTMLElement>;

  @ViewChild('home') home: ElementRef<HTMLElement>;
  @ViewChild('empresa') empresa: ElementRef<HTMLElement>;
  @ViewChild('produtos') produtos: ElementRef<HTMLElement>;
  @ViewChild('orcamento') orcamento: ElementRef<HTMLElement>;
  @ViewChild('contato') contato: ElementRef<HTMLElement>;

  @ViewChild('divFormOrcamento') divFormOrcamento: ElementRef<HTMLElement>;
  @ViewChild('divEmpresa') divEmpresa: ElementRef<HTMLElement>;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private formBuilder: FormBuilder,
    private emailService: EmailService,
    private messageService: MessageService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loading = false;
    this.config = {
      animationType: ngxLoadingAnimationTypes.circleSwish,
      primaryColour: '#034f89',
      secondaryColour: '#606060',
      fullScreenBackdrop: true
    }
    this.width = window.innerWidth;
    this.scrollPosition = document.body.scrollTop || document.documentElement.scrollTop;
    this.items = [
      {label: 'HOME', command: (event) => {
        this.home.nativeElement.scrollIntoView({behavior: 'smooth'});
      }},
      {label: 'PRODUTOS', command: (event) => {
        this.produtos.nativeElement.scrollIntoView({behavior: 'smooth'});
      }},
      {label: 'A EMPRESA', command: (event) => {
        this.empresa.nativeElement.scrollIntoView({behavior: 'smooth'});
      }},
      {label: 'ORÇAMENTO', command: (event) => {
        this.orcamento.nativeElement.scrollIntoView({behavior: 'smooth'});
      }},
      {label: 'CONTATO', command: (event) => {
        this.contato.nativeElement.scrollIntoView({behavior: 'smooth'});
      }}
    ];

    this.formOrcamento = this.formBuilder.group({
      nome: ['', [
        Validators.required,
        Validators.minLength(3)
      ]],
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      telefone: ['', [
        Validators.required,
        Validators.minLength(10)
      ]],
      produto: ['', Validators.required],
      msg: ['', Validators.required]
    });

    this.formContato = this.formBuilder.group({
      nome: ['', [
        Validators.required,
        Validators.minLength(3)
      ]],
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      telefone: ['', [
        Validators.required,
        Validators.minLength(10)
      ]],
      assunto: ['', Validators.required],
      msg: ['', Validators.required]
    });

    this.galleryOptions = [
      {
        width: '100%',
        imageAnimation: NgxGalleryAnimation.Slide,
        imageAutoPlay: true,
        imageAutoPlayInterval: 3000,
        thumbnailsColumns: 4,
        height: '422.6px'
      },
      {
        breakpoint: 999,
        height: '500px',
        thumbnailsColumns: 3
      },
      {
        breakpoint: 500,
        height: '400px',
        thumbnailsColumns: 3
      }
    ];

    this.galleryImages = [
      {
        small: '../assets/img/empresa-1.jpg',
        medium: '../assets/img/empresa-1.jpg',
        big: '../assets/img/empresa-1.jpg'
      },
      {
        small: '../assets/img/empresa-2.jpg',
        medium: '../assets/img/empresa-2.jpg',
        big: '../assets/img/empresa-2.jpg'
      },
      {
        small: '../assets/img/empresa-3.jpg',
        medium: '../assets/img/empresa-3.jpg',
        big: '../assets/img/empresa-3.jpg'
      },
      {
        small: '../assets/img/empresa-4.jpg',
        medium: '../assets/img/empresa-4.jpg',
        big: '../assets/img/empresa-4.jpg'
      }
    ];
  }

  ngDoCheck() {
    this.changeDetector.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = window.innerWidth;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrollPosition = document.body.scrollTop || document.documentElement.scrollTop;
  }

  get menuMobile() {
    if (this.width < 1100) {
      this.brandMenu.nativeElement.classList.remove('mx-auto');
      this.navMenu.nativeElement.classList.remove('fixed-top');
      this.navMenu.nativeElement.classList.remove('bg-custom');
      this.navMenu.nativeElement.classList.add('bg-custom-mobile');
      return true;
    } else {
      this.brandMenu.nativeElement.classList.add('mx-auto');
      this.navMenu.nativeElement.classList.add('fixed-top');
      this.navMenu.nativeElement.classList.add('bg-custom');
      this.navMenu.nativeElement.classList.remove('bg-custom-mobile');
      return false;
    }
  }

  get scrooling() {
    if (this.scrollPosition > 50) {
      return true;
    }
  }

  get background() {
    if (this.scrollPosition > 50) {
      return '#606060';
    } else {
      return 'transparent';
    }
  }

  submitContato() {
    this.loading = true;
    let param = this.formContato.getRawValue();
    this.emailService.enviaEmail(param).subscribe(
      (res) => {
        this.loading = false;
        this.msg = "E-mail enviado com sucesso!";
        this.messageService.setShowMessage(true);
      },

      (err) => {
        this.loading = false;
        this.msg = "E-mail não enviado!";
        this.messageService.setShowMessage(true);
      }
    );
  }

  submit() {
    this.loading = true;
    let param = this.formOrcamento.getRawValue();
    this.emailService.enviaEmail(param).subscribe(
      (res) => {
        this.loading = false;
        this.msg = "E-mail enviado com sucesso!";
        this.messageService.setShowMessage(true);
      },

      (err) => {
        this.loading = false;
        this.msg = "E-mail não enviado!";
        console.log(err);
        this.messageService.setShowMessage(true);
      }
    );
  }

  goToHome() {
    this.home.nativeElement.scrollIntoView({behavior: 'smooth'});
  }

  goToEmpresa() {
    this.empresa.nativeElement.scrollIntoView({behavior: 'smooth'});
  }

  goToProdutos() {
    this.produtos.nativeElement.scrollIntoView({behavior: 'smooth'});
  }

  goToOrcamento() {
    this.orcamento.nativeElement.scrollIntoView({behavior: 'smooth'});
  }

  goToContato() {
    this.contato.nativeElement.scrollIntoView({behavior: 'smooth'});
  }

  setModalFelonite() {
    this.dadosModal = {
      titulo: 'Fenolite',
      subtitulo: '( FR-1 - Flame Retardant Class 1 ) face simples:',
      img: '../assets/img/composite.png',
      conteudo: [
        { text: 'Laminado cobreado a base de resina fenólica e papel celulose.' },
        { text: 'Devido à base de papel celulose, há restrições para ambientes de alta umidade.' },
        { text: 'Possui boa isolação elétrica e suporta temperaturas intermediárias.' },
        { text: 'O custo é mais acessível se comparado com outros tipos de materiais.' },
        { text: 'Tonalidade marrom e a espessura mais utilizada é de 1,6 mm.' }
      ]
    };

    this.ngxSmartModalService.resetModalData('modalProdutos');
    this.ngxSmartModalService.setModalData(this.dadosModal, 'modalProdutos');
    this.ngxSmartModalService.open('modalProdutos');
  }

  setModalFibra() {
    this.dadosModal = {
      titulo: 'Fibra de vidro',
      subtitulo: '(FR-4 - Flame Retardant Class 4) face simples e dupla face:',
      img: '../assets/img/fibradevidro.png',
      conteudo: [
        { text: 'Laminado cobreado à base de tecido de vidro e resina epóxi' },
        { text: 'Muito baixa absorção de umidade, excelente resistência mecânica e ótimas propriedades dielétricas, apresentando assim maior vida útil em ambientes úmidos, agressivos e de maior salinidade.' },
        { text: 'Excelente estabilidade dimensional e alta resistência à temperatura.' },
        { text: 'Apresenta tonalidade esverdeada e a espessura mais utilizada é a de 1,6 mm.' }
      ]
    };

    this.ngxSmartModalService.resetModalData('modalProdutos');
    this.ngxSmartModalService.setModalData(this.dadosModal, 'modalProdutos');
    this.ngxSmartModalService.open('modalProdutos');
  }

  setModalComposite() {
    this.dadosModal = {
      titulo: 'Composite',
      subtitulo: '( CEM-1 - Composite Epoxy Materials Class 1) face simple:',
      img: '../assets/img/fenolite.png',
      conteudo: [
        { text: 'Laminado cobreado a base de tecido de fibra de vidro, papel celulose e resina epóxi.' },
        { text: 'Propriedades elétricas, resistência à temperatura, resistência mecânica e custo normalmente intermediários entre o Fenolite e a Fibra de vidro.' },
        { text: 'Tonalidade branca ou amarelada e a espessura mais utilizada é de 1,6 mm.' }
      ]
    };

    this.ngxSmartModalService.resetModalData('modalProdutos');
    this.ngxSmartModalService.setModalData(this.dadosModal, 'modalProdutos');
    this.ngxSmartModalService.open('modalProdutos');
  }

  setModalMetalCore() {
    this.dadosModal = {
      titulo: 'Alumínio',
      subtitulo: '(Metal Core ou MCPCB) face simples:',
      img: '../assets/img/metalcore.png',
      conteudo: [
        { text: 'Laminado cobreado à base de alumínio, que contém um isolante separando o alumínio da lâmina de cobre.' },
        { text: 'Utilizado na fabricação de placas de circuitos impressos com tecnologia LED (alta potência) para otimizar a dissipação de calor gerado pelo LED.' },
        { text: 'A espessura padrão encontrada no mercado é de 1,5 mm.' }
      ]
    };

    this.ngxSmartModalService.resetModalData('modalProdutos');
    this.ngxSmartModalService.setModalData(this.dadosModal, 'modalProdutos');
    this.ngxSmartModalService.open('modalProdutos');
  }

  get largura() {
    return this.width;
  }

  get heightTextArea() {
    if (this.divFormOrcamento) {
      let height = this.divFormOrcamento.nativeElement.clientHeight;
      return height.toString() + 'px';
    } else {
      return '0px';
    }
  }

  get marginTextoEmpresa() {
    if (this.divEmpresa) {
      if ((this.divEmpresa.nativeElement.clientWidth - 580) < 20) {
        return (this.divEmpresa.nativeElement.clientWidth - 490).toString() + 'px';
      } else {
        return (this.divEmpresa.nativeElement.clientWidth - 580).toString() + 'px';
      }
    }
  }

  get padContato() {
    if (this.largura < 1199) {
      return '25px';
    } else {
      return '80px';
    }
  }

}
